import { defineStore } from "pinia";
import { computed, ref } from "vue";

import metricaService from "@/services/metrica.service";

export const useToolUsageStore = defineStore("toolUsage", () => {
  // State
  const usage = ref(null); // null = todavía no se cargó
  let inFlight = null;
  let loadToken = 0;

  // Getters
  const usageById = computed(() => {
    const map = new Map();
    for (const item of usage.value || []) {
      map.set(item.moduleId, {
        recentCount: item.recentCount || 0,
        totalCount: item.totalCount || 0,
      });
    }
    return map;
  });

  const getToolUsage = async () => {
    if (usage.value !== null) return usage.value;
    if (inFlight) return inFlight;

    const token = ++loadToken;
    const request = metricaService
      .fetchToolUsage()
      .then((response) => {
        if (token !== loadToken) return usage.value ?? [];
        usage.value = response.data || [];
        return usage.value;
      })
      .catch(() => {
        if (token !== loadToken) return usage.value ?? [];
        // el hero cae al orden por defecto, nunca rompe
        usage.value = [];
        return usage.value;
      })
      .finally(() => {
        if (inFlight === request) inFlight = null;
      });

    inFlight = request;
    return request;
  };

  // Actions
  const registerUse = (moduleId) => {
    if (usage.value === null) return;
    const existing = usage.value.find((item) => item.moduleId === moduleId);
    if (existing) {
      existing.recentCount += 1;
      existing.totalCount += 1;
    } else {
      usage.value.push({ moduleId, recentCount: 1, totalCount: 1 });
    }
  };

  const resetState = () => {
    loadToken += 1;
    usage.value = null;
    inFlight = null;
  };

  return { usage, usageById, getToolUsage, registerUse, resetState };
});
